import { useInfiniteQuery } from "@tanstack/react-query";
import { getCMAApiClient } from "@cma/shared/apis/comps/cma/api-factories";

const LIST_CMAS_QUERY_KEY = "list-cmas-mine";

export const DEFAULT_LIMIT = 12;
export const DEFAULT_ORDER_BY = "updated-desc";

export const buildListCmasQueryKey = (
  params = { limit: DEFAULT_LIMIT, orderBy: DEFAULT_ORDER_BY },
) => [LIST_CMAS_QUERY_KEY, params] as const;

export function useListCmas() {
  const api = getCMAApiClient();

  const query = useInfiniteQuery({
    queryKey: buildListCmasQueryKey(),
    queryFn: ({ pageParam }) =>
      api.cMAControllerListMine({
        page: pageParam,
        limit: DEFAULT_LIMIT,
        orderBy: DEFAULT_ORDER_BY,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const { currentPage, totalPages } = lastPage.meta;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

  return {
    presentations: query.data?.pages.flatMap((p) => p.items) ?? [],
    totalItems: query.data?.pages[0]?.meta.totalItems ?? 0,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
  };
}
